const CAPSULE_NAME_REQUIRED = 'Capsule name is required.';
const CAPSULE_NAME_INVALID_FORMAT =
  'Use lowercase letters, numbers, and hyphens only. Start and end with a letter or number.';
const CAPSULE_DESCRIPTION_REQUIRED = 'Capsule description is required.';

export const CAPSULE_NAME_MAX_LENGTH = 63;
export const CAPSULE_DESCRIPTION_MIN_LENGTH = 10;
export const CAPSULE_DESCRIPTION_MAX_LENGTH = 255;

type Response = {
  success: boolean;
  errorMessage?: string;
};

export type RegisterCapsuleStepOneValues = {
  capsuleName: string;
  capsuleDescription: string;
};

export type RegisterCapsuleStepOneErrors = {
  capsuleName?: string;
  capsuleDescription?: string;
};

type StepOneResponse = {
  success: boolean;
  errors: RegisterCapsuleStepOneErrors;
};

const CAPSULE_NAME_PATTERN = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;

export function validateCapsuleNameForStepOne(capsuleName: string): Response {
  const trimmedCapsuleName = capsuleName.trim();

  if (!trimmedCapsuleName) {
    return { success: false, errorMessage: CAPSULE_NAME_REQUIRED };
  }

  if (trimmedCapsuleName.length > CAPSULE_NAME_MAX_LENGTH) {
    return {
      success: false,
      errorMessage: `Keep the capsule name ${CAPSULE_NAME_MAX_LENGTH} characters or fewer.`,
    };
  }

  if (!CAPSULE_NAME_PATTERN.test(trimmedCapsuleName)) {
    return { success: false, errorMessage: CAPSULE_NAME_INVALID_FORMAT };
  }

  return { success: true, errorMessage: undefined };
}

export function validateCapsuleDescriptionForStepOne(capsuleDescription: string): Response {
  const trimmedCapsuleDescription = capsuleDescription.trim();

  if (!trimmedCapsuleDescription) {
    return { success: false, errorMessage: CAPSULE_DESCRIPTION_REQUIRED };
  }

  if (trimmedCapsuleDescription.length < CAPSULE_DESCRIPTION_MIN_LENGTH) {
    return {
      success: false,
      errorMessage: `Use at least ${CAPSULE_DESCRIPTION_MIN_LENGTH} characters for the capsule description.`,
    };
  }

  if (capsuleDescription.length > CAPSULE_DESCRIPTION_MAX_LENGTH) {
    return {
      success: false,
      errorMessage: `Keep the capsule description ${CAPSULE_DESCRIPTION_MAX_LENGTH} characters or fewer.`,
    };
  }

  return { success: true, errorMessage: undefined };
}

export function validateRegisterCapsuleStepOne(
  values: RegisterCapsuleStepOneValues,
): StepOneResponse {
  const nameValidation = validateCapsuleNameForStepOne(values.capsuleName);
  const descriptionValidation = validateCapsuleDescriptionForStepOne(values.capsuleDescription);
  const errors: RegisterCapsuleStepOneErrors = {};

  if (nameValidation.success === false) {
    errors.capsuleName = nameValidation.errorMessage;
  }

  if (descriptionValidation.success === false) {
    errors.capsuleDescription = descriptionValidation.errorMessage;
  }

  return {
    success: Object.keys(errors).length === 0,
    errors,
  };
}
